import { render, staticRenderFns } from "./doctorRegisterHelp.vue?vue&type=template&id=f8099054&scoped=true&"
import script from "./doctorRegisterHelp.vue?vue&type=script&lang=js&"
export * from "./doctorRegisterHelp.vue?vue&type=script&lang=js&"
import style0 from "./doctorRegisterHelp.vue?vue&type=style&index=0&id=f8099054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8099054",
  null
  
)

export default component.exports